import styled from 'styled-components';

export const StyledContainer = styled.div`
  box-sizing: border-box;
  height: 100%;
  padding-top: 0.5rem;
`;
